
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

import HtmlEditor from '../HtmlEditor';
import Input from '../Input';
import InlineError from '../InlineError';

class TimetableRow extends React.Component {

    _getRemovePeriodButton(index) {

        if (this.props.showRemoveButton) {

            return (
                <span onClick={ this.props.removeButtonClicked.bind(this, index) }
                      styleName="remove-task-icon">
                    &times;
                </span>
            );
        }
    }

    render() {

        return (
            <div styleName="timetable-input-row">

                <div styleName="time-input-container">

                    <Input { ...this.props.period.time }
                           errors={ this.props.period.time.error }
                           className={ style['time-input'] } />

                    <InlineError errors={ this.props.period.time.error } />

                </div>

                <div stylename="task-input-container">

                    <HtmlEditor { ...this.props.period.description }
                                theme="bubble"
                                errors={ this.props.period.description.error }
                                className={ style['task-input'] }
                                contentsClassName={ style['task-editor'] } />

                    <InlineError errors={ this.props.period.description.error } />

                </div>

                <div styleName="remove-task-container">
                    { this._getRemovePeriodButton(this.props.index) }
                </div>

            </div>
        );
    }
}

export default CSSModules(TimetableRow, style);


// WEBPACK FOOTER //
// ./components/TimetableRow/index.js